import {
  BasicSelect,
  SelectOption
} from '@vmware-react/clarity/dist/basic-inputs';
import React from 'react';
import { DSelectField, DSelectValue } from './types';
import { randomId } from './util';

interface Props {
  field: DSelectField;
  value: DSelectValue;
  error?: string;
  touched?: boolean;
  hidden?: boolean;
  handleChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  handleBlur: (event: React.FocusEvent<HTMLSelectElement>) => void;
}

export default (props: Props) => {
  const {
    field,
    error,
    touched,
    hidden,
    value,
    handleChange,
    handleBlur
  } = props;
  const hasError = typeof error === 'string' && error.length > 0;

  const id = randomId(field.name);
  return (
    <BasicSelect
      id={id}
      label={field.label}
      required={field.required}
      hidden={hidden}
      error={hasError && touched}
      errorMessage={error}
      helpText={field.helperText}
      helpTextPosition={field.helperTextPosition}
      helperTextToolTipConfig={field.helperTextToolTipConfig}
      name={field.name}
      value={value}
      onChange={handleChange}
      onBlur={handleBlur}
      disabled={field.disabled}>
      <SelectOption value="">{field.placeholder || '--Select--'}</SelectOption>
      {field.options.map((option, index) => (
        <SelectOption
          key={index}
          value={option.value}
          disabled={option.disabled}>
          {option.textLabel}
        </SelectOption>
      ))}
    </BasicSelect>
  );
};
